import _ from 'lodash';

const SONICU_ROOT_ROUTES = [
    'enterprise-dashboard',
    'device-association',
    'probe-calibration',
    'probe-association',
    'shipping-checklist',
    'sites',
    'scripts',
    'enhanced-audits',
    'SonicuTools',
    'probe-association',
    'probe-calibration',
    'shipping-checklist',
    'data-concentrator',
    'operations',
    'production',
    'engineering',
    'export-users',
    'api'
];

// Cache the company ID at module level
let cachedCompanyId = null;
let cachedPathname = null;

export function useCompany() {
    const getCompanyId = (parentSite = 'sonicu') => {
        const currentPathname = window.location.pathname;

        // Return cached value if pathname hasn't changed
        if (cachedCompanyId !== null && cachedPathname === currentPathname) {
            return cachedCompanyId;
        }

        const path = currentPathname.split('/');
        const companyId = path[1];

        const result = SONICU_ROOT_ROUTES.indexOf(companyId) !== -1
            ? parentSite
            : companyId;

        // Cache the result
        cachedCompanyId = result;
        cachedPathname = currentPathname;

        return result;
    };

    const buildCompanyRoute = (route, company = null) => {
        const targetCompany = _.isNil(company)
            ? getCompanyId()
            : company;
        return `/${targetCompany}/${route}`;
    };

    const buildCompanyApiInternalRoute = (route, company = null) => {
        const targetCompany = _.isNil(company)
            ? getCompanyId()
            : company;
        return `/api-internal/${targetCompany}/${route}`;
    };

    const buildRoute = (route) => {
        return `/${route}`;
    };

    const buildApiInternalRoute = (route) => {
        return `/api-internal/${route}`;
    };

    const isSonicuRootRoute = (route = null) => {
        const targetRoute = route || window.location.pathname.split('/')[1];
        return SONICU_ROOT_ROUTES.indexOf(targetRoute) !== -1;
    };

    return {
        getCompanyId,
        buildCompanyRoute,
        buildCompanyApiInternalRoute,
        buildRoute,
        buildApiInternalRoute,
        isSonicuRootRoute,
        SONICU_ROOT_ROUTES
    };
}